import { render, staticRenderFns } from "./SAccountList.vue?vue&type=template&id=05a798a6"
import script from "./SAccountList.vue?vue&type=script&lang=js"
export * from "./SAccountList.vue?vue&type=script&lang=js"
import style0 from "./SAccountList.vue?vue&type=style&index=0&id=05a798a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports